export const pathnames = {
  HOME: '/',
  REGISTRATION: '/registration',
  STEP: '/step',
  STEP_ID: '/step/:stepId',
  GET_STEP_PATH: stepId => `/step/${stepId}`,
};
